import _ from 'lodash'
import { BeckyExperiments } from '@wix/thunderbolt-commons'
import { componentCssFactory } from './componentCssCompNode'
import { CssFeatures } from './cssFeatures.types'
import { responsiveLayoutCssFeature } from './responsiveLayout/responsiveLayoutCssFeature'
import { variablesCssFeature } from './variables/variablesCssFeature'
import { screenInCssFeature } from './screenIn/screenInCssFeature'
import { landingPageCssFeature } from './landingPageCss/landingPageCssFeature'
import { rotatedComponentsStyleFeature } from './rotatedComponentsStyle/rotatedComponentsStyleFeature'

export const componentCssFeatures: CssFeatures = {
	rotatedComponentsStyle: rotatedComponentsStyleFeature,
	landingPages: landingPageCssFeature,
	responsiveLayout: responsiveLayoutCssFeature,
	variables: variablesCssFeature,
	screenIn: screenInCssFeature,
}

export type IsExperimentOpen = (experimentName: keyof BeckyExperiments) => boolean

export const componentCssFeaturesProvider = (isExperimentOpen: IsExperimentOpen) => {
	const activeCssFeatures = _.pickBy(componentCssFeatures, (feature) => isExperimentOpen(feature.experimentName))

	const componentNodes = Object.values(activeCssFeatures).reduce(
		(acc, { renderableNodes, intermediateNodes }) => ({ ...acc, ...renderableNodes, ...intermediateNodes }),
		{ componentCss: componentCssFactory(activeCssFeatures) }
	)

	const usedDataMaps = new Set(Object.values(activeCssFeatures).flatMap(({ dataMaps }) => dataMaps))

	return { componentNodes, usedDataMaps }
}
